import { render, staticRenderFns } from "./EvaluationFileDataTable.vue?vue&type=template&id=129dc794&scoped=true&"
import script from "./EvaluationFileDataTable.vue?vue&type=script&lang=js&"
export * from "./EvaluationFileDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129dc794",
  null
  
)

export default component.exports